<template>
  <div class="setting-popup effect-options"  v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      设置
    </div>
    <div class="setting-popup__content">
      <div class="radios" v-if="animation === 'slide'">
        <div class="radios__title">
          动画速度
        </div>
        <ul class="radios__list">
          <!--             :class="{active: oneSpriteEasing && (oneSpriteEasing === item.alias || oneSpriteEasing === item.num)}"-->
          <li
            class="radios__item"
            v-for="(item, key) in easingList"
            :class="{active: item.active}"
            :key="key"
            @click="setEasing(item)"
          >
            <i></i>
            <span>{{item.text}}</span>
          </li>
        </ul>
      </div>
      <div class="list">
        <div class="list__title">
          动画方向
        </div>
        <ul>
          <li
            class="list__item"
            :class="{active: item.active}"
            v-for="(item, index) in showingList"
            :key="index"
            @click="selectEffect({ item, index, inOut: inOut })"
          >
            <div class="list__figure" :class="{[`icon-wrapper-${item.icon || item.to}`]: true}">
              <i class="icon" :class="{[`icon-effect-${item.icon || item.to}`]: true, 'is-out': inOut === 'out'}"></i>
            </div>
            <div class="list__caption">{{item.text}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup"></div>
  </div>
</template>

<script>
import popup from '../mixins/popup';

export default {
  mixins: [popup],
  data () {
    return {
      popupType: 'effectOptions',
      showingList: [],
      inOut: 'in',
      slideList: {
        out: [
          {text: '向左移出', type: 'LeftOut', to: 'left', direction: '', active: false},
          {text: '向右移出', type: 'RightOut', to: 'right', direction: '', active: false},
          {text: '向上移出', type: 'UpOut', to: 'up', direction: '', active: false},
          {text: '向下移出', type: 'DownOut', to: 'down', direction: '', active: false},
        ],
        in: [
          {text: '从左移入', type: 'LeftIn', to: 'right', direction: '', active: false},
          {text: '从右移入', type: 'RightIn', to: 'left', direction: '', active: false},
          {text: '从上移入', type: 'UpIn', to: 'down', direction: '', active: false},
          {text: '从下移入', type: 'DownIn', to: 'up', direction: '', active: false},
        ],
      },
      smearList: {
        out: [
          {text: '向左擦除', type: 'Smear', to: 'left', direction: 'w', active: false, icon: 'smear-w'},
          {text: '向右擦除', type: 'Smear', to: 'right', direction: 'e', active: false, icon: 'smear-e'},
          {text: '向上擦除', type: 'Smear', to: 'up', direction: 'n', active: false, icon: 'smear-n'},
          {text: '向下擦除', type: 'Smear', to: 'down', direction: 's', active: false, icon: 'smear-s'},
        ],
        in: [
          {text: '从左擦入', type: 'Smear', to: 'right', direction: 'e', active: false, icon: 'smear-e'},
          {text: '从右擦入', type: 'Smear', to: 'left', direction: 'w', active: false, icon: 'smear-w'},
          {text: '从上擦入', type: 'Smear', to: 'down', direction: 's', active: false, icon: 'smear-s'},
          {text: '从下擦入', type: 'Smear', to: 'up', direction: 'n', active: false, icon: 'smear-n'},
        ]
      },
      easingList: [
        {type: 'easeIn', text: '加速', active: false, num: 1, alias: 'easeOutExpo'},
        {type: 'easeOut', text: '减速', active: false, num: 2, alias: 'easeOutQuint'},
        {type: 'linear', text: '匀速', active: false, num: 0, alias: 'linear'}
      ],
      animation: ''
    }
  },
  computed: {
    oneSpriteEasing () {
      if (this.SelectSprites_Msg && this.SelectSprites_Msg.length === 1) {
        return this.inOut === 'out'
          ? this.SelectSprites_Msg[0].effect.exitAnim.easing
          : this.SelectSprites_Msg[0].effect.easing
      }
      return false
    },
    oneSprite () {
      if (this.SelectSprites_Msg && this.SelectSprites_Msg.length === 1) {
        return this.SelectSprites_Msg[0]
      }
      return false
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {

          this.showList();
        }
      }
    }
  },
  methods: {
    showList () {
      let { inOut, animation } = this.boxData.data.effectOptions;
      this.showingList = this[animation + 'List'][inOut];
      this.inOut = inOut;
      this.animation = animation;

      this.updateItmes();
    },

    selectEffect ({
      item,
      index,
      inOut
    }= {}) {
      this.updateEffect({
        item,
        index,
        inOut
      });

      this.updateItmes();
      this.$bus.emit('effectOptions.selectEffect');
    },

    updateEffect ({
      item,
      index,
      inOut
    } = {}) {
      this.SelectSprites_Msg.forEach((sprite) => {
        let code = item.type;
        let inOutType;

        if (inOut === 'in') {
          let {start, end} = sprite.effect.entranceAnim;
          if (code === 'None') {
            start = end;
          } else {
            start = Math.max(end - 500, 0);
          }

          sprite.updateEffect({
            code,
            direction: item.direction,
            entranceAnim: {
              start,
              end
            }
          }, true);
          inOutType = 'entrance';
        }
        if (inOut === 'out') {
          let {start, end} = sprite.effect.exitAnim;
          if (code === 'None') {
            end = start;
          } else {
            if(start >= this.TOOL.selectedScenes.duration) {
              start = this.TOOL.selectedScenes.duration - 500;
            }
            end = Math.min(start + 500, this.TOOL.selectedScenes.duration);
          }

          sprite.updateEffect({
            direction: sprite.effect.direction,
            exitAnim: {
              type: code,
              direction: item.direction,
              start,
              end
            }
          }, true);
          inOutType = 'exit';
        }
        sprite.effect.init();
        this.$bus.emit('updateEffect_vue', {
          sprite: sprite,
          effect: sprite.effect || {},
          type: inOutType
        });
      });
    },

    updateItmes (sprite) {
      let isEffectsSame = true;
      if (this.SelectSprites_Msg.length > 1 && this.inOut === 'in') {
        isEffectsSame = this.SelectSprites_Msg.every((s) => {
          return s.effect.code === this.SelectSprites_Msg[0].effect.code
        })
      }
      if (this.SelectSprites_Msg.length > 1 && this.inOut === 'out') {
        isEffectsSame = this.SelectSprites_Msg.every((s) => {
          return s.effect.exitAnim.type
            === this.SelectSprites_Msg[0].effect.exitAnim.type
        })
      }
      if (!isEffectsSame) {
        this.showingList.forEach((item) => {
          item.active = false;
        });
        return;
      }

      if (!sprite) {
        sprite = this.SelectSprites_Msg.length
          ? this.SelectSprites_Msg[0]
          : {};
      }

      let effect = sprite.effect;
      let inEff = effect.type || effect.code || 'None';
      let outEff = effect.exitAnim.type;
      let eff = this.inOut === 'in' ? inEff : outEff;

      if (this.animation === 'slide') {
        let inEasing = effect.easing;
        let outEasing = effect.exitAnim.easing;
        if (outEasing == null) {
          sprite.updateEffect({
            exitAnim: {
              easing: 'easeOutExpo'
            }
          });
          outEasing = effect.exitAnim.easing;
        }
        let easing = this.inOut === 'in' ? inEasing : outEasing;
        this.easingList.forEach((item) => {
          if (item.alias === easing || item.num === easing) {
            item.active = true;
            this.$set(item, 'active', true);
          } else {
            item.active = false;
            this.$set(item, 'active', false);
          }
        })
      }

      if (this.animation === 'smear') {
        let inDire = effect.direction;
        let outDire = effect.exitAnim.direction;
        let dire = this.inOut === 'in' ? inDire : outDire;
        this.showingList.forEach((item) => {
          if (item.direction === dire) {
            item.active = true;
          } else {
            item.active = false;
          }
        })
        return;
      }
      this.showingList.forEach((item) => {
        if (item.type === eff) {
          item.active = true;
        } else {
          item.active = false;
        }
      })
    },

    setEasing (item) {
      this.SelectSprites_Msg.forEach((s) => {
        this.setEasing_(item, s)
      })
    },

    setEasing_ (item, sprite) {
      // if (!this.oneSprite) {
      //   return;
      // }
      // let sprite = this.oneSprite;
      let inOutType;
      let effect = sprite.effect;
      if (this.inOut === 'out') {
        sprite.updateEffect({
          exitAnim: {
            type: /LeftOut|RightOut|UpOut|DownOut/.test(effect.exitAnim.type)
              ? effect.exitAnim.type
              : 'LeftOut',
            easing: item.alias
          }
        }, true);
        inOutType = 'exit';
      } else {
        sprite.updateEffect({
          code: /LeftIn|RightIn|UpIn|DownIn/.test(effect.code)
            ? effect.code
            : 'LeftIn',
          easing: item.alias
        }, true);
        inOutType = 'entrance';
      }
      sprite.effect.init();
      this.$bus.emit('updateEffect_vue', {
        sprite: sprite,
        effect: sprite.effect || {},
        type: inOutType
      });

      this.$bus.emit('effectOptions.selectEffect');
      this.updateItmes();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors.scss";
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  max-height: 562px;
  z-index: 35;
  border-radius: 6px 6px 3px 3px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }
}

.radios {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 13px;

  &__title {
    margin-bottom: 13px;
    font-size: 14px;
    text-align-last: left;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    &>i {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: solid 1px #9692a9;
    }
    &>span {
      padding-left: 5px;
    }

    &.active>i {
      background-color: #9692a9;
      box-shadow: 0 0 0 2px #ffffff inset;
    }
  }
}

.list {
  margin-top: 33px;
  padding-left: 20px;
  padding-right: 20px;

  &:first-child {
    margin-top: 0;
  }

  &__title {
    margin-bottom: 13px;
    font-size: 14px;
    text-align-last: left;
  }

  & > ul {
    display: flex;
    flex-wrap: wrap;
  }
  &__item {
    margin-right: 18px;
    margin-bottom: 15px;
    cursor: pointer;

    &:nth-child(3n) {
      margin-right: 0;
    }

    &.active .list__figure {
      box-shadow: 0 0 0 2px $c2;
    }
  }
  &__figure {
    width: 60px;
    height: 58px;
    background-color: #f0f0f8;
    border-radius: 4px;
    overflow: hidden;
  }
  &__caption {
    margin-top: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/effectOptions.vue